<template>
  <v-container fluid class="py-0" grid-list-md>
    <v-row justify="center">
      <v-col cols="12" md="9" mx-auto>
        <v-flex xs12 v-if="lAction === 'view'">
          <v-card-title class="title primary--text">
            Search Resident
          </v-card-title>
          <v-form ref="sForm" @submit.prevent="searchResident()">
            <v-card>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-text-field
                    v-model="lSearch.contact_phone"
                    label= "Phone Number"
                    hide-details
                    maxlength="15"
                    type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    v-model="lSearch.cust_name"
                    label= "Name"
                    hide-details
                    maxlength="50"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    v-model="lSearch.comm_name"
                    label= "Community Name"
                    hide-details
                    maxlength="50"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="clear">Clear</v-btn>
                <v-btn text type="submit" color="accent" :disabled="beingSaved">search</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-flex>

        <v-flex xs12 class="pt-2" v-if="lAction === 'view' && residentInfo.length > 0">
          <v-card flat>
            <v-card-title class="title primary--text">
              Search Result ({{residentInfo.length}} Records)
            </v-card-title>
            <v-card-text class="pa-1">
              <v-data-table
              :headers="resHeadSm"
              :items="residentInfo"
              hide-default-footer
              disable-pagination
              class="elevation-2"
              :sort-by="['cust_name', 'comm_name']"
              multi-sort
              :mobile-breakpoint="0"
              >
              <template slot="item" slot-scope="props">
                <tr @click="updateResident(props.item)">
                  <td>{{ props.item.cust_name}}</td>
                  <td>{{ props.item.comm_name}}</td>
                  <td>{{ props.item.block_nm}}</td>
                  <td>{{ props.item.unit_no}}</td>
                  <td>{{ props.item.contact_phone}}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-container v-if= "lAction === 'update'" class="pa-0" fluid full-height grid-list-md>
        <v-layout row wrap>
          <v-flex xs12>
            <v-form ref="rForm" @submit.prevent="saveResidentInfo(lAction)">
              <v-card flat>
                <v-card-title class="title">
                  {{ handy.startWithUpper(lAction) +' Resident' }}
                </v-card-title>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-text-field
                      label="Name"
                      v-model="lResident.cust_name"
                      :rules="[rules.required]"
                      hide-details
                      maxlength="50"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                      label="Community Name"
                      v-model="lResident.comm_name"
                      :rules="[rules.required]"
                      hide-details
                      maxlength="50"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-combobox
                      v-model="lResident.block_nm"
                      label="Block"
                      :items="blockList"
                      :rules="[rules.required]"
                      hide-details
                      maxlength="25"
                      @input="findBlockId()"
                      ></v-combobox>
                    </v-flex>
                    <v-flex xs6>
                      <v-combobox
                      label="Unit no."
                      v-model="lResident.unit_no"
                      :rules="[rules.required]"
                      :items="unitList"
                      hide-details
                      maxlength="10"
                      @input="findUnitId()"
                      ></v-combobox>
                    </v-flex>
                    <v-flex xs12>
                      <v-radio-group row class="pt-0" v-model="lResident.ownership" mandatory hide-details>
                        <v-radio
                        label="Owner"
                        value="Owner"
                        ></v-radio>
                        <v-radio
                        label="Family of owner"
                        value="Family of owner"
                        ></v-radio>
                        <v-radio
                        label="Tenant"
                        value="Tenant"
                        ></v-radio>
                        <v-radio
                        label="Family of tenant"
                        value="Family of tenant"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs5>
                      <v-checkbox
                      label="MC Member"
                      v-model="lResident.is_mc_member"
                      hide-details
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs7 v-if="lResident.is_mc_member">
                      <v-select class="pa-0" v-model="lResident.role_id"
                      placeholder="Role"
                      :items="rolesList"
                      item-text = "role_name"
                      item-value = "role_id"
                      :rules="[rules.required]"
                      hide-details
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 class="mt-3">
                      <span class="primary--text">Contact Information</span>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                      label="Mobile no."
                      v-model="lResident.contact_phone"
                      hide-details
                      :rules="[rules.required]"
                      maxlength="15"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                      label="E-mail"
                      v-model="lResident.contact_email"
                      :rules="[rules.required]"
                      hide-details
                      maxlength="50"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 class="mt-3">
                      <span class="primary--text">Other Information (optional)</span>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                      label="Intercom no."
                      v-model="lResident.int_extn"
                      hide-details
                      maxlength="10"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                      label="Emergency phone"
                      v-model="lResident.emergency_phone"
                      hide-details
                      maxlength="15"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-select
                      label="Gender"
                      :items="['Male', 'Female']"
                      v-model="lResident.gender"
                      hide-details
                      ></v-select>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                      label="Blood group"
                      v-model="lResident.blood_group"
                      hide-details
                      maxlength="10"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                      label="Occupation"
                      v-model="lResident.occupation"
                      hide-details
                      maxlength="15"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                      label="Hobbies"
                      v-model="lResident.hobbies"
                      hide-details
                      maxlength="50"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click.stop="cancelChanges">Cancel</v-btn>
                  <v-btn type="submit" color="accent" :disabled="beingSaved">save</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-col>
  </v-col>
</v-row>
<!-- snack bar for error reporting -->
<v-snackbar :color="sbarCol" v-model="sbar" :timeout="3000" multi-line>
  <span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
export default {
  data() {
    return {
      lAction: '',
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      config: config,
      handy: handy,
      rules: handy.rules,
      beingSaved: false,
      resHeadSm: [
        { text: 'Customer Name', value: 'cust_name'},
        { text: 'Community Name', value: 'comm_name' },
        { text: 'Block', value: 'block_nm' },
        { text: 'Unit', value: 'unit_no' },
        { text: 'Phone', value: 'contact_phone' }
      ],
      blockList: [],
      unitList: [],
      rolesList: [],
      units: [],
      blocks: [],
      roles: [],
      residentInfo: [],
      lResident: {},
      lSearch: {},
      prevMC: ''
    }
  },
  mounted () {
    this.lAction = 'view'
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loading () {
      this.load = true
      setTimeout(() => {
        this.load = false
      }, 2000)
    },
    searchResident () {
      if (!this.lSearch.contact_phone && !this.lSearch.cust_name && !this.lSearch.comm_name) {
        this.msg('Please enter any search criteria', 0)
        return
      }
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          contact_phone: this.lSearch.contact_phone,
          cust_name: this.lSearch.cust_name,
          comm_name: this.lSearch.comm_name
        }
      }
      this.axios.get(config.API_URL + '/searchResidentByPhoneNameComm/', qry)
      .then(response => {
        this.residentInfo = response.data
        if (!this.residentInfo.length) {
          this.msg('No records found for given search criteria', 0)
          return
        }
        this.lAction = 'view'
      })
      .catch(err => {
        this.msg(err)
        this.residentInfo = []
      })
    },
    loadBlocks (curCommId) {
      var qry = {
        params: {
          comm_id: curCommId
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getBlocksByCommId/', qry)
      .then(response => {
        this.blocks = response.data
        this.blockList = this.blocks.map(rec => rec.block_nm)
        if (this.lResident.block_id) {
          this.loadUnits(this.lResident.block_id)
        } else {
          this.unitList = []
        }
      })
      .catch(err => {
        this.msg(err.response.data)
        this.blocks = []
        this.blockList = []
      })
    },
    loadUnits () {
      var qry = {
        params: {
          block_id: this.lResident.block_id,
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getUnitsByBlockId/', qry)
      .then(response => {
        this.units = response.data
        this.unitList = this.units.map(rec => rec.unit_no)
      })
      .catch(err => {
        this.msg(err.response.data)
        this.unitList = []
      })
    },
    loadRoles (curRole) {
      var qry = {
        params: {
          comm_id: curRole
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getRolesByCommId/', qry)
      .then(response => {
        this.roles = response.data
        this.rolesList = this.roles.filter(rec => (rec.role_name !== 'Administrator' && rec.role_name !== 'Resident' && !rec.staff_role_id))
      })
      .catch(err => {
        this.roles = []
        this.rolesList = []
        this.msg(err.response.data)
      })
    },
    clear () {
      this.$refs.sForm.reset()
    },
    saveResidentInfo (action) {
      if (!this.$refs.rForm.validate()) {
        return
      }
      this.beingSaved = true
      this.findBlockId()
      this.findUnitId()
      setTimeout(() => {
        // pre logic
        if (this.lResident.old_unit_id === this.lResident.unit_id) {
          this.lResident.old_unit_id = null
        }
        if (this.prevMC !== this.lResident.is_mc_member) { // role changed
          if (!this.lResident.is_mc_member) { // MC member access removed
            this.lResident.role_id = this.roles.find(rec => rec.role_name === 'Resident').role_id
          } // else MC member access given, keep the chosen role
        }
        // save after a time out to find unit id incase user clicks on save without coming out of unit field
        this.axios.post(config.SMARTILITY_API_URL + '/resident/update', this.lResident)
        .then(response => {
          if (this.lAction === 'update') {
            var idx = this.residentInfo.findIndex(obj => obj.cust_id === this.lResident.cust_id)
            Object.assign(this.residentInfo[idx], this.lResident)
          }
          this.lAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data)
          this.beingSaved = false
        })
      }, 100)
    },
    cancelChanges () {
      this.lAction = 'view'
      this.beingSaved = false
    },
    findBlockId () {
      var idx = this.blocks.findIndex(rec => rec.block_nm === this.lResident.block_nm)
      if (idx >= 0) {
        this.lResident.block_id = this.blocks[idx].block_id
        this.loadUnits()
      } else {
        this.lResident.block_id = ''
        this.unitList = []
        this.msg('Entered block is not found, it will be created newly', 2)
      }
    },
    findUnitId () {
      var idx = this.units.findIndex(rec => rec.unit_no === this.lResident.unit_no)
      if (idx >= 0) {
        this.lResident.unit_id = this.units[idx].unit_id
      } else {
        this.lResident.unit_id = ''
        this.msg('Entered unit is not found, it will be created newly', 2)
      }
    },
    updateResident (curResident) {
      this.lResident = Object.assign({}, curResident)
      this.lResident.old_unit_id = curResident.unit_id
      this.prevMC = curResident.is_mc_member
      this.lAction = 'update'
      this.loadBlocks(this.lResident.comm_id)
      this.loadRoles(this.lResident.comm_id)
      this.loadUnits()
    }
  }
}
</script>
